import { render, staticRenderFns } from "./InputCopy.vue?vue&type=template&id=c7cc03ec&scoped=true&"
import script from "./InputCopy.vue?vue&type=script&lang=js&"
export * from "./InputCopy.vue?vue&type=script&lang=js&"
import style0 from "./InputCopy.vue?vue&type=style&index=0&id=c7cc03ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cc03ec",
  null
  
)

export default component.exports